import { type RouteRecordRaw } from 'vue-router'

import { FeatureFlags } from '@/plugins/featureFlags'

import { websiteBuilderModuleRouter } from '../builder/websiteBuilderModuleRouter'
import { isWebsiteVariantBAvailable } from '../websiteBuilderAvailability'

export const websiteBuilderRouter: RouteRecordRaw[] = [
  ...websiteBuilderModuleRouter,
  {
    component: async () => import('../views/WebsiteBuilderPagesView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel.page'),
      condenseSidebar: true,
      title: 'website.pages',
    },
    name: 'brand.website.pages.home',
    path: 'pages',
  },
  {
    component: async () =>
      import('../views/WebsiteBuilderAnnouncementsView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel'),
      title: 'website.announcements',
    },
    name: 'brand.website.announcements',
    path: 'announcements',
  },
  {
    component: async () =>
      import('../views/WebsiteBuilderHestiaIframeView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel.page'),
      condenseSidebar: true,
      hestiaPath: '/website/content',
      title: 'website.content',
    },
    name: 'brand.website.content',
    path: 'content',
  },
  {
    component: async () =>
      import('../views/WebsiteBuilderHestiaIframeView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel.page'),
      commandPaletteVisible: () => isWebsiteVariantBAvailable(FeatureFlags),
      condenseSidebar: true,
      hestiaPath: '/website/design',
      title: 'website.design',
    },
    name: 'brand.website.design',
    path: 'design',
  },
]
